import React from 'react';
import { compose, graphql, withApollo } from 'react-apollo';
import { Link, Route, Switch } from 'react-router-dom';
import { Button, Divider } from 'semantic-ui-react';
import { CreateLitigation } from '../../mutations/CreateLitigation';
import { EmailMessage } from '../../queries/EmailMessage';
import mapConnection from '../../utils/connectionMapper';
import getTaskTitle from '../../utils/getTaskTitle';
import Content from '../Content';
import { airlineAnswerOptions } from '../dropdowns/AirlineAnswerDropdown';
import EmailCrop from '../EmailCrop';
import EmailResponder from '../EmailResponder';
import InterpretMail from '../InterpretMail';
import SelectLitigationReasonModal from '../modals/SelectLitigationReasonModal';
import PathView from '../PathView';
import Settled from '../Settled';
import TaskContainer from '../TaskContainer';
import VerifyDocument from '../VerifyDocument';

class PresentEmail extends React.Component {
  state = { litigationModalOpen: false };

  isClaimInBPhase = crmState => {
    return crmState && crmState.charAt(0) === 'b';
  };

  handleLitigationClick = () => this.setState({ litigationModalOpen: true });

  handleCreateLitigation = reason => {
    this.setState({ loading: true, litigationModalOpen: false });
    const { task } = this.props;
    const input = {
      taskId: task.id,
      litigation: {
        claimId: task.claimId,
        ...reason
      }
    };
    this.props
      .CreateLitigation({
        variables: {
          input
        }
      })
      .then(() => {
        this.setState({ loading: false });
        this.props.onTaskComplete();
      })
      .catch(error => {
        this.setState({ loading: false });
        console.error(error);
      });
  };

  render = () => {
    const {
      crmState,
      task,
      loading,
      claim,
      withLocation,
      emailMessage,
      airlineAmicableAnswer,
      airlinePreLitigationAnswer,
      onClaimClosed
    } = this.props;
    const isClaimInBPhase = this.isClaimInBPhase(crmState);
    const taskTitle = getTaskTitle(task);

    const senderType = emailMessage && emailMessage.senderType;
    const isFromAirline = senderType === 'airline';
    return (
      <Content fullWidth>
        <PathView
          paths={[
            { name: 'Tasks', path: '/tasks' },
            { name: task.id, path: `/task/${task.id}` }
          ]}
        />
        <TaskContainer
          title={taskTitle}
          date={task.createdAt}
          id={task.id}
          priority={task.priority}
          icon="hashtag"
          claimId={task.claimId}
          loading={loading || this.state.loading}
          hideClaim={false}
          onClaimClosed={onClaimClosed}
        >
        {this.state.litigationModalOpen &&   <SelectLitigationReasonModal
            name="airlineAmicableAnswer"
            open={this.state.litigationModalOpen}
            dimmer={true}
            hideModal={() => this.setState({ litigationModalOpen: false })}
            operation="litigation"
            options={airlineAnswerOptions}
            handleClose={({ description, ...reason }) =>
              Object.values(reason).find(el => el !== null)
                ? this.handleCreateLitigation(reason)
                : undefined
            }
            isDescriptionVisible={false}
            claimState={claim.crmState}
            airlineAmicableAnswer={airlineAmicableAnswer}
            airlinePreLitigationAnswer={airlinePreLitigationAnswer}
          />}
          <InterpretMail claim={claim} email={emailMessage} {...this.props} />
          <Divider hidden />
          <Link to={withLocation(`/re`)}>
            <Button floated="right" primary>
              Respond
            </Button>
          </Link>
          <Link to={withLocation(`/fwd`)}>
            <Button floated="right" primary>
              Forward
            </Button>
          </Link>
          <Link to={withLocation(`/crop`)}>
            <Button floated="right" primary>
              Add documents to claim
            </Button>
          </Link>
          {isClaimInBPhase && isFromAirline ? (
            <Settled
              claim={claim}
              refetch={this.props.EmailMessage.refetch}
              taskId={task.id}
              location={this.props.location}
              claimId={task.claimId}
            />
          ) : null}

          {isClaimInBPhase || /c[0-3]+/.test(claim.crmState) ? (
            <Button
              floated="right"
              primary
              onClick={this.handleLitigationClick}
            >
              Rejection
            </Button>
          ) : null}
        </TaskContainer>
      </Content>
    );
  };
}

class HandleMessageTask extends React.Component {
  withLocation = path => ({
    pathname: `/task/${this.props.task.id}${path}`,
    state: this.props.location.state
  });

  render() {
    const emailMessage = this.props.EmailMessage.emailMessage || {};
    const claim = emailMessage.claim || {};
    const task = this.props.task;
    const taskType = task.taskType;
    const { airlineAmicableAnswer, airlinePreLitigationAnswer } =
      task && task.claim;
    const senderType = emailMessage && emailMessage.senderType;
    const { onClaimClosed } = this.props;

    return (
      <Switch>
        <Route
          path="/task/:id"
          exact
          render={() => (
            <PresentEmail
              crmState={claim && claim.crmState}
              claim={claim}
              task={task}
              loading={this.props.EmailMessage.loading}
              withLocation={this.withLocation}
              emailMessage={emailMessage}
              airlineAmicableAnswer={airlineAmicableAnswer}
              airlinePreLitigationAnswer={airlinePreLitigationAnswer}
              {...this.props}
            />
          )}
        />
        <Route
          path="/task/:id/re"
          render={props => {
            return (
              <Content fullWidth>
                <PathView
                  paths={[
                    { name: 'Tasks', path: '/tasks' },
                    { name: task.id, path: `/task/${task.id}` },
                    { name: 'Respond' }
                  ]}
                />
                <TaskContainer
                  title={taskType.name}
                  date={task.createdAt}
                  id={task.id}
                  priority={task.priority}
                  icon="hashtag"
                  claimId={task.claimId}
                  loading={this.props.EmailMessage.loading}
                  hideClaim={false}
                  onClaimClosed={onClaimClosed}
                >
                  <EmailResponder
                    taskId={this.props.task.id}
                    claim={claim}
                    email={emailMessage}
                    onEmailSent={this.props.onTaskComplete}
                    {...this.props}
                  >
                    <Link to={this.withLocation(``)}>
                      <Button floated="right">Back</Button>
                    </Link>
                  </EmailResponder>
                </TaskContainer>
              </Content>
            );
          }}
        />
        <Route
          path="/task/:id/fwd"
          render={props => {
            return (
              <Content fullWidth>
                <PathView
                  paths={[
                    { name: 'Tasks', path: '/tasks' },
                    { name: task.id, path: `/task/${task.id}` },
                    { name: 'Forward' }
                  ]}
                />
                <TaskContainer
                  title={taskType.name}
                  date={task.createdAt}
                  id={task.id}
                  priority={task.priority}
                  icon="hashtag"
                  claimId={task.claiId}
                  loading={this.props.EmailMessage.loading}
                  hideClaim={false}
                  onClaimClosed={onClaimClosed}
                >
                  <EmailResponder
                    forward
                    taskId={this.props.task.id}
                    claim={claim}
                    email={emailMessage}
                    onEmailSent={this.props.onTaskComplete}
                    {...this.props}
                  >
                    <Link to={this.withLocation(``)}>
                      <Button floated="right">Back</Button>
                    </Link>
                  </EmailResponder>
                </TaskContainer>
              </Content>
            );
          }}
        />
        <Route
          path="/task/:id/crop"
          render={props => {
            return (
              <Content fullWidth>
                <PathView
                  paths={[
                    { name: 'Tasks', path: '/tasks' },
                    { name: task.id, path: `/task/${task.id}` },
                    { name: 'Add documents to claim' }
                  ]}
                />
                <TaskContainer
                  title={taskType.name}
                  date={task.createdAt}
                  id={task.id}
                  priority={task.priority}
                  icon="hashtag"
                  claimId={task.claimId}
                  loading={this.props.EmailMessage.loading}
                  hideClaim={false}
                  onClaimClosed={onClaimClosed}
                >
                  <EmailCrop {...this.props} />
                  <Link to={this.withLocation(`/verify`)}>
                    <Button floated="right" primary>
                      Next
                    </Button>
                  </Link>
                  <Link to={this.withLocation(``)}>
                    <Button floated="right">Back</Button>
                  </Link>
                </TaskContainer>
              </Content>
            );
          }}
        />
        <Route
          path="/task/:id/verify"
          render={props => {
            return (
              <Content fullWidth>
                <PathView
                  paths={[
                    { name: 'Tasks', path: '/tasks' },
                    { name: task.id, path: `/task/${task.id}` },
                    { name: 'Add documents to claim' }
                  ]}
                />
                <TaskContainer
                  title={taskType.name}
                  date={task.createdAt}
                  id={task.id}
                  priority={task.priority}
                  icon="hashtag"
                  claimId={task.claimId}
                  loading={this.props.EmailMessage.loading}
                  hideClaim={false}
                  onClaimClosed={onClaimClosed}
                >
                  <VerifyDocument
                    onSaved={this.props.onTaskComplete}
                    documents={this.documents()}
                    claim={claim}
                    senderType={senderType}
                    loading={this.props.EmailMessage.loading}
                    {...this.props}
                  />
                </TaskContainer>
              </Content>
            );
          }}
        />
      </Switch>
    );
  }

  documents() {
    const emailMessage = this.props.EmailMessage.emailMessage || {};
    return emailMessage.documentsConnection
      ? mapConnection(emailMessage.documentsConnection)
      : [];
  }
}

const HandleMessageTaskWithData = compose(
  withApollo,
  graphql(EmailMessage, {
    name: 'EmailMessage',
    options: props => {
      return {
        variables: {
          id: props.task.emailMessage.id
        }
      };
    }
  }),
  graphql(CreateLitigation, { name: 'CreateLitigation' })
)(HandleMessageTask);

export default HandleMessageTaskWithData;



// WEBPACK FOOTER //
// ./src/component/tasks/HandleMessageTask.js